module.exports = "https://static.wagwalking.com/_next/static/images/petted-544cffa438ab65020839367e6bbc63fe.png";